export default "__VITE_ASSET__CaVa6h3s__"